import styles from "./chatState.module.css";

// A centered note in place of a chat list or thread: nothing there yet,
// nothing found, or a load that failed (tone "error", with a retry).
const ChatState = ({ icon, title, text, actionLabel, onAction, tone = "neutral" }) => (
  <div
    className={`${styles.state} ${tone === "error" ? styles.error : ""}`.trim()}
    role={tone === "error" ? "alert" : undefined}
  >
    {icon && <span className={styles.icon}>{icon}</span>}
    <p className={styles.title}>{title}</p>
    {text && <p className={styles.text}>{text}</p>}
    {actionLabel && onAction && (
      <button type="button" className={styles.action} onClick={onAction}>
        {actionLabel}
      </button>
    )}
  </div>
);

export default ChatState;
